export default __webpack_public_path__ + "static/CrystalHover-cc80b28e6a8414ee4aae1ed4d7abb538.png";